import has from 'lodash/has';
import {
  CHANGE_PASSWORD_FAILURE,
  CHANGE_PASSWORD_REQUEST,
  CHANGE_PASSWORD_SUCCESS,
  CHECK_PASSWORD_SUCCESS,
} from 'new/stores/changePassword/action';
import { CHANGE_PASSWORD_ERROR } from 'js/constants/MessageConstants';

const initialState = {
  type: '',
  error: null,
};

const changePassword = (
  state = initialState,
  action: {
    type: string;
    result: any;
    error: any;
  },
) => {
  switch (action.type) {
    case CHANGE_PASSWORD_REQUEST:
      return {
        ...state,
        ...action,
      };
    case CHANGE_PASSWORD_SUCCESS:
      return {
        ...state,
        ...action.result,
        type: CHANGE_PASSWORD_SUCCESS,
        error: null,
      };
    case CHECK_PASSWORD_SUCCESS:
      return {
        ...state,
        entropy: action.result,
        error: null,
      };

    case CHANGE_PASSWORD_FAILURE: {
      let errorMessage =
        has(action, 'error') && action.error !== 'Unauthorized'
          ? action.error
          : CHANGE_PASSWORD_ERROR;
      return {
        ...state,
        type: CHANGE_PASSWORD_FAILURE,
        error: errorMessage,
      };
    }

    default:
      return state;
  }
};

export default changePassword;
